import { MagazineType } from "enums";
import { IconName } from "types";

export const magazine = [
  {
    name: "All Magazine",
    id: null,
    icon: "Book1" as IconName,
  },
  {
    name: "Post & Articles",
    id: [MagazineType.Post, MagazineType.Article],
    icon: "DocumentCopy" as IconName,
  },
  {
    name: "Posts",
    id: [MagazineType.Post],
    icon: "Document" as IconName,
  },
  {
    name: "Articles",
    id: [MagazineType.Article],
    icon: "DocumentText" as IconName,
  },
  {
    name: "Store",
    id: [MagazineType.Store],
    icon: "Shop" as IconName,
  },
];
